import React from "react";
import { Link } from "react-router-dom";
import { LogIn, LogOut, ShieldCheck } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";

export default function UserMenu() {
  const { t } = useLang();
  const { user, loading, login, logout } = useAuth();
  if (loading) return <span className="w-9 h-9" />;

  if (!user) {
    return (
      <button onClick={login} aria-label={t("review_login")} className="w-9 h-9 inline-flex items-center justify-center rounded-full border border-stoneLine bg-card text-ink hover:bg-ochre hover:text-white hover:border-ochre transition-colors" data-testid="login-button">
        <LogIn className="w-4 h-4" />
      </button>
    );
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button aria-label={user.name} className="w-9 h-9 rounded-full border-2 border-ochre overflow-hidden bg-sandDeep" data-testid="user-menu-trigger">
          {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" referrerPolicy="no-referrer" /> : <span className="text-xs font-bold">{user.name?.[0]}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-3 rounded-2xl border-stoneLine bg-sand" data-testid="user-menu">
        <div className="text-sm font-semibold text-ink truncate" data-testid="user-name">{user.name}</div>
        <div className="text-xs text-muted-foreground truncate mb-3">{user.email}</div>
        {user.is_admin && (
          <Link to="/admin" className="flex items-center gap-2 text-sm px-3 py-2 rounded-lg hover:bg-sandDeep/60 text-ink" data-testid="admin-link">
            <ShieldCheck className="w-4 h-4 text-oasis" /> {t("moderation")}
          </Link>
        )}
        <button onClick={logout} className="w-full flex items-center gap-2 text-sm px-3 py-2 rounded-lg hover:bg-sandDeep/60 text-ink" data-testid="logout-button">
          <LogOut className="w-4 h-4" /> {t("logout")}
        </button>
      </PopoverContent>
    </Popover>
  );
}
